<template>
  <div class="gf_corner-item">
    <label class="gf_corner-item--title paragraph-12-regular-150">Radius (px)</label>
    <div class="gf_corner-item__setting">
      <div class="setting-left">
        <div class="corner-input">
          <i class="icon icon-corner-top-left prefix-icon" />
          <div class="wrap-input-corner">
            <GfInputNumber
              id="top-left"
              input-class="setting-input-corner"
              :style-container="{ border: 'none' }"
              :readonly="false"
              :is-display-number-button="false"
              :value="corner.top_left"
              :min="0"
              @on-change="changeValue($event, 'top_left')" />
          </div>
        </div>
      </div>
      <div class="setting-right">
        <div class="corner-input">
          <i class="icon icon-corner-top-right prefix-icon" />
          <div class="wrap-input-corner">
            <GfInputNumber
              id="top-right"
              input-class="setting-input-corner"
              :style-container="{ border: 'none' }"
              :readonly="false"
              :is-display-number-button="false"
              :value="corner.top_right"
              :min="0"
              @on-change="changeValue($event, 'top_right')" />
          </div>
        </div>
      </div>
    </div>
    <div class="gf_corner-item__action-mode">
      <div
        :key="`${isModeChangeAll}`"
        v-tooltip.top="isModeChangeAll ? 'All Together' : 'Individual'"
        class="gf_corner-item__action-mode_btn"
        :data-is-apply="isModeChangeAll"
        @click="onEditSettingMode">
        <i v-show="isModeChangeAll" class="icon icon-corner-constraint gf_corner-item__action-mode_btn_img" />
        <i
          v-show="!isModeChangeAll"
          class="icon icon-corner-unconstraint gf_corner-item__action-mode_btn_img"
          alt="mode" />
      </div>
    </div>
    <div class="gf_corner-item__setting">
      <div class="setting-left">
        <div class="corner-input">
          <i class="icon icon-corner-bottom-left prefix-icon" />
          <div class="wrap-input-corner">
            <GfInputNumber
              id="bottom-left"
              input-class="setting-input-corner"
              :style-container="{ border: 'none' }"
              :readonly="false"
              :is-display-number-button="false"
              :value="corner.bottom_left"
              :min="0"
              @on-change="changeValue($event, 'bottom_left')" />
          </div>
        </div>
      </div>
      <div class="setting-right">
        <div class="corner-input">
          <i class="icon icon-corner-bottom-right prefix-icon" />
          <div class="wrap-input-corner">
            <GfInputNumber
              id="bottom-right"
              input-class="setting-input-corner"
              :style-container="{ border: 'none' }"
              :readonly="false"
              :is-display-number-button="false"
              :value="corner.bottom_right"
              :min="0"
              @on-change="changeValue($event, 'bottom_right')" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface DataInterface {
  cornerIndependentSetting: string;
  corner: any;
  unitDefault: string;
}

const MODE_CORNER: any = {
  ALL: 'all',
  INDEPENDENT: 'independent',
};

export default defineComponent({
  name: 'CornerItem',
  props: {
    cornerItem: {
      type: Object,
    },
    indexItem: {
      type: Number,
    },
  },
  data: (): DataInterface => ({
    cornerIndependentSetting: 'static/icons/corner-independent-settings.svg',
    corner: {},
    unitDefault: 'px',
  }),
  computed: {
    isModeChangeAll: function () {
      return this.cornerItem?.value.mode == MODE_CORNER['ALL'];
    },
  },
  created() {
    this.handleValueCorner();
  },
  methods: {
    onEditSettingMode() {
      if (this.isModeChangeAll) {
        (this.cornerItem as any).value.mode = MODE_CORNER['INDEPENDENT'];
      } else {
        (this.cornerItem as any).value.mode = MODE_CORNER['ALL'];
      }
      this.handleValueCorner();
      return;
    },
    changeValue(data: any, corner: string) {
      console.log('data: ', data);
      console.log('corner: ', corner);
      console.log('this.isModeChangeAll: ', this.isModeChangeAll);
      if (this.isModeChangeAll) {
        this.corner = {
          top_left: parseInt(data.val),
          top_right: parseInt(data.val),
          bottom_right: parseInt(data.val),
          bottom_left: parseInt(data.val),
        };
      } else {
        this.corner[`${corner}`] = data.val;
      }
      this.setValueToConnerIndependent();
    },
    setValueToConnerIndependent() {
      const topLeft = this.setUnitToValue(this.corner['top_left']);
      const topRight = this.setUnitToValue(this.corner['top_right']);
      const bottomRight = this.setUnitToValue(this.corner['bottom_right']);
      const bottomLeft = this.setUnitToValue(this.corner['bottom_left']);
      (this.cornerItem as any).value.value = `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`;
    },
    setUnitToValue(value: string): string {
      return `${value}${this.unitDefault}`;
    },
    handleValueCorner(): void {
      let cornerValue: string = this.cornerItem?.value.value;
      if (this.isModeChangeAll) {
        if (cornerValue.split(' ').length > 1) {
          const value = cornerValue.split(' ');
          cornerValue = value[0];
        }
        cornerValue = cornerValue.replace(this.unitDefault, '');
        this.corner = {
          top_left: parseInt(cornerValue),
          top_right: parseInt(cornerValue),
          bottom_right: parseInt(cornerValue),
          bottom_left: parseInt(cornerValue),
        };
      } else {
        const detachValue = cornerValue.split(' ');
        if (detachValue.length == 1) {
          const valueConnerAll = parseInt(detachValue[0].replace(this.unitDefault, ''));
          this.corner = {
            top_left: valueConnerAll,
            top_right: valueConnerAll,
            bottom_right: valueConnerAll,
            bottom_left: valueConnerAll,
          };
        } else {
          this.corner = {
            top_left: parseInt(detachValue[0].replace(this.unitDefault, '')),
            top_right: parseInt(detachValue[1].replace(this.unitDefault, '')),
            bottom_right: parseInt(detachValue[2].replace(this.unitDefault, '')),
            bottom_left: parseInt(detachValue[3].replace(this.unitDefault, '')),
          };
        }
      }
      this.setValueToConnerIndependent();
      return;
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.gf_corner-item {
  padding: 8px;

  &--title {
    color: map-get($editor-hightlight, '2');
    padding-bottom: 0;
    margin-bottom: 8px;
  }

  &__setting {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .setting-left {
      flex: 0 0 50%;
      max-width: 50%;
      display: flex;
      justify-content: flex-start;

      .corner-input {
        .prefix-icon {
          position: absolute;
          top: 50%;
          right: 8px;
          transform: translateY(-50%);
          pointer-events: none;
        }

        .wrap-input-corner {
          :deep(.setting-input-corner) {
            padding-right: 28px;
            padding-left: 8px;
          }
        }
      }
    }

    .setting-right {
      flex: 0 0 50%;
      max-width: 50%;
      display: flex;
      justify-content: flex-end;

      .corner-input {
        .prefix-icon {
          position: absolute;
          top: 50%;
          left: 8px;
          transform: translateY(-50%);
          pointer-events: none;
        }
      }
    }

    .corner-input {
      position: relative;
      display: flex;
      width: 60px;

      .wrap-input-corner {
        // eslint-disable-next-line vue-scoped-css/no-unused-selector
        .gf_control-inumber {
          margin: unset;
        }

        // eslint-disable-next-line vue-scoped-css/no-unused-selector
        .gf_control-inumber__container {
          border: unset;
        }

        :deep(.setting-input-corner) {
          height: 32px;
          padding: 8px;
          background: map-get($hybrid-shade-dark, '400');
          border: 1px solid map-get($hybrid-shade-dark, '200');
          color: map-get($hybrid-shade-light, '100');
          padding-top: 8px;
          padding-bottom: 8px;
          border-radius: $radius;
          padding-left: 28px;

          &:hover,
          &:focus {
            border: 1px solid map-get($primary-blue-ui-kit, '300');
          }
        }
      }
    }
  }

  &__action-mode {
    @include flex-align-justify-center;
    width: 100%;
    height: 40px;

    &_btn {
      cursor: pointer;
      padding: 10px 10px;
      height: 40px;
      width: 40px;
      font-size: 20px;
      border-radius: 3px;

      &:hover {
        background-color: $black2;
      }
    }
  }

  .prefix-icon {
    font-size: 16px;
  }
}
</style>
